<script setup lang="ts">
import { nextTick, ref } from 'vue'
import router, { routerPush } from '@/router'
import { useGlobalStore } from '@/stores/global'
import type { Host, Season } from '@/services/api'
import { formattedSeasonDates } from '@/utils/helpers-season'
import { api } from '@/services'

const globalStore = useGlobalStore()

interface Props {
  host: Host
}

const props = defineProps<Props>()
const host = props.host

const pageSeasonId = ref<number>()
const pageWeekId = ref<number>()

const panel = ref()

async function addWeekAndSetActive(seasonId: number) {
  // create a new week, and set it to be active
  console.log(seasonId)
}

/**
 *
 * @param seasonId
 * @param weekId
 */
// async function setActiveWeek(seasonId: number, weekId: number) {
//   // not sure if we should be setting the active week?
//   try {
//     globalStore.incrementLoading()
//     const result = api.api.activeWeek(seasonId, weekId).then((res) => res.data)
//     if (result) {
//       routerPush('week', { id: String(weekId) })
//     }
//   } catch (error) {
//     console.error(['Set Active Week', error])
//   } finally {
//     globalStore.decrementLoading()
//   }
// }

/**
 *
 */
async function setActiveSeason(hostId: number, seasonId: number) {
  try {
    globalStore.incrementLoading()
    const result = api.api.activeSeason(hostId, seasonId).then((res) => res.data)
    if (result) {
      nextTick()
      router.push({ name: 'season', params: { id: String(seasonId) } })
    }
  } catch (error) {
    console.error(['Set Active Season', error])
  } finally {
    globalStore.decrementLoading()
  }
}
</script>
<template>
  <v-card class="mt-2 mb-2 rounded-lg tertiary" height="fit-content">
    <v-card-title class="text-h5 text-white bg-primary d-flex justify-space-between align-center">
      {{ host.name }}
      <v-spacer />
      <v-btn
        icon="mdi-magnify"
        variant="text"
        size="small"
        class="text-green"
        v-if="host.id > 0"
        @click="routerPush('host', { id: String(host.id) })"
      />
    </v-card-title>
    <v-card-subtitle>
      <p>{{ host.game_day }} ${{ host.buyin }}</p>
    </v-card-subtitle>
    <v-card-text>
      <v-sheet class="py-4">
        <!--            <pre><code>{{ host.active_season }}</code></pre>-->
        <v-expansion-panels v-model="panel" variant="accordion">
          <v-expansion-panel v-if="host.active_season" :key="host.id + '-activeSeason'">
            <v-expansion-panel-title>
              <p>
                <b>{{ host.active_season.name }}</b>
                <span v-html="formattedSeasonDates(host.active_season as Season)"></span>
              </p>
            </v-expansion-panel-title>
            <v-expansion-panel-text>
              <v-list density="compact" :slim="true">
                <v-list-item
                  :key="'addWeek'"
                  v-if="host.active_season.id"
                  @click="addWeekAndSetActive(host.active_season.id)"
                  class="cursor-pointer"
                  :slim="true"
                >
                  Add new week
                </v-list-item>
                <v-list-item
                  v-for="week in host.active_season.weeks"
                  :key="week.value"
                  class="cursor-pointer"
                  :class="{
                    active: Number(week.value) == Number(pageWeekId)
                  }"
                  :to="{ name: 'week', params: { id: week.value } }"
                  >{{ week.text }}
                  <!--@click="setActiveWeek(host.active_season.id, week.value)"-->
                </v-list-item>
              </v-list>
            </v-expansion-panel-text>
          </v-expansion-panel>
          <!--        <pre><code>{{ host }}</code></pre>-->
          <v-expansion-panel :key="host.id + '-players'" title="Players">
            <v-expansion-panel-text>
              <v-list>
                <v-list-item v-for="player in host.players" :key="player.id" density="compact">
                  <template v-if="player.is_active">
                    <v-icon size="x-small" icon="mdi-check-circle" class="text-success"></v-icon>
                  </template>
                  {{ player.name }}
                  <template v-if="player.is_admin">
                    <v-icon size="x-small" icon="mdi-security" class="text-primary"></v-icon>
                  </template>
                  <!--                  <code>-->
                  <!--                    <pre>{{ player }}</pre>-->
                  <!--                  </code>-->
                </v-list-item>
              </v-list>
            </v-expansion-panel-text>
          </v-expansion-panel>
          <v-expansion-panel :key="host.id + '-seasons'" title="Seasons">
            <v-expansion-panel-text>
              <v-list-item v-for="season in host.seasons" :key="season.value" density="compact">
                <v-icon
                  size="small"
                  :icon="
                    season.value === pageSeasonId ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'
                  "
                  :class="season.value === pageSeasonId ? 'text-success' : 'text-red'"
                  @click="setActiveSeason(host.id, season.value)"
                ></v-icon>
                <span @click="setActiveSeason(host.id, season.value)"> {{ season.text }}</span>
              </v-list-item>
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>
    </v-card-text>
  </v-card>
</template>
